import React, { useState, useEffect } from 'react';
import contactService from '../../services/contactService';

export default function ContactDetail({ contact, onClose, onEdit }) {
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (contact?.id) {
            fetchInvoices();
        }
    }, [contact]);

    const fetchInvoices = async () => {
        setLoading(true);
        try {
            const response = await contactService.getContactInvoices(contact.id);
            setInvoices(response.data || []);
        } catch (err) {
            console.error('Error fetching invoices:', err);
            setError('Impossible de charger l\'historique des factures');
        } finally {
            setLoading(false);
        }
    };

    if (!contact) return null;

    return (
        <div className="contact-detail-overlay" onClick={onClose}>
            <div className="contact-detail-modal" onClick={e => e.stopPropagation()}>
                <div className="detail-header">
                    <h2>{contact.name}</h2>
                    <button className="btn-close" onClick={onClose}>✕</button>
                </div>

                <div className="detail-body">
                    {/* Contact Info Section */}
                    <div className="detail-section">
                        <h3>Informations Contact</h3>
                        <div className="info-grid">
                            <div className="info-item">
                                <span className="info-label">Email</span>
                                <span className="info-value">{contact.email || '-'}</span>
                            </div>
                            <div className="info-item">
                                <span className="info-label">Téléphone</span>
                                <span className="info-value">{contact.phone || '-'}</span>
                            </div>
                            <div className="info-item">
                                <span className="info-label">Type</span>
                                <span className="info-value">
                                    {contact.type === 'individual' ? 'Particulier' : 'Société'}
                                </span>
                            </div>
                            <div className="info-item">
                                <span className="info-label">Catégorie</span>
                                <span className="info-value" style={{ textTransform: 'capitalize' }}>
                                    {contact.category}
                                </span>
                            </div>
                            <div className="info-item">
                                <span className="info-label">Statut</span>
                                <span className="info-value">
                                    {contact.isActive ? '✅ Actif' : '❌ Inactif'}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Invoices Section */}
                    <div className="detail-section">
                        <h3>Historique des Commandes / Factures</h3>

                        {loading ? (
                            <div className="loading-spinner">Chargement...</div>
                        ) : error ? (
                            <div className="error-message">{error}</div>
                        ) : invoices.length > 0 ? (
                            <div className="invoices-table-container">
                                <table className="invoices-table">
                                    <thead>
                                        <tr>
                                            <th>N° Commande</th>
                                            <th>Date</th>
                                            <th>Montant</th>
                                            <th>Statut</th>
                                            <th>Suivi</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {invoices.map(invoice => (
                                            <tr key={invoice.id}>
                                                <td>{invoice.orderNumber}</td>
                                                <td>{new Date(invoice.createdAt).toLocaleDateString()}</td>
                                                <td>{Number(invoice.totalPrice).toFixed(2)} €</td>
                                                <td>
                                                    <span className={`status-badge status-${invoice.status}`}>
                                                        {invoice.status}
                                                    </span>
                                                </td>
                                                <td>
                                                    {invoice.trackingUrl ? (
                                                        <a href={invoice.trackingUrl} target="_blank" rel="noopener noreferrer">
                                                            Suivre
                                                        </a>
                                                    ) : '-'}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="empty-invoices">
                                Aucune commande trouvée pour ce contact.
                            </div>
                        )}
                    </div>
                </div>

                <div className="detail-footer">
                    <button className="btn btn-secondary" onClick={onClose}>Fermer</button>
                    <button className="btn btn-primary" onClick={() => onEdit(contact)}>Modifier</button>
                </div>
            </div>
        </div>
    );
}
